import React from 'react'
import { NavLink } from 'react-router-dom'
import Navbar from './Navbar'
import logo from "../images/logo2.png"
import styled from 'styled-components'

const Header = () => {
  return (
    <MainHeader>
        <NavLink to ="/" >
            <img src={logo} alt = 'logo' className='logo'/>
        </NavLink>

        <Navbar/>
    </MainHeader>
  )
}

const MainHeader = styled.header`
padding: 0 4.8rem;
height: 10rem;
background-color: ${({theme})=> theme.colors.bg};
display: flex;
justify-content: space-between;
align-items: center;

.logo{
  height:100%;
  max-width: 100% 
}
`;

export default Header